import { CommonElementModule } from './../../common_elements/common_element.module';
import { SharedModule } from '@app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppGetQuoteListComponent } from './app-get-quote-list/app-get-quote-list.component';
import { AppGetQuoteNoteComponent } from './app-get-quote-list/app-get-quote-note/app-get-quote-note.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptService } from '@app/core/_base/crud/utils/intercept.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartialsModule } from '@app/views/partials/partials.module';
import { MaterialModule } from 'mat-modules';
import { AppBrandManagementComponent } from './brand-management/app-brand-management/app-brand-management.component';
import { ModalCreateBrandComponent } from './brand-management/modal-create-brand/modal-create-brand.component';
import { ModalCreatePostsPolicyComponent } from './app-policy-posts-management/modal-create-posts-policy/modal-create-posts-policy.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { AppWarehouseManagementComponent } from './warehouse-management/app-warehouse-management/app-warehouse-management.component';
import { ModalCreateWarehouseComponent } from './warehouse-management/modal-create-warehouse/modal-create-warehouse.component';
import { ProductManagementComponent } from './product-management/product-management.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { AllProductComponent } from './product-management/all-product/all-product.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxSummernoteModule } from 'ngx-summernote';
import { ModalUploadImageComponent } from './edit-product/modal-upload-image/modal-upload-image.component';
import { ModalTreeCategoryComponent } from './edit-product/modal-tree-category/modal-tree-category.component';
import { InStockComponent } from './product-management/in-stock/in-stock.component';
import { OutOfStockComponent } from './product-management/out-of-stock/out-of-stock.component';
import { ZoomImageComponent } from './edit-product/zoom-image/zoom-image.component';
import { ModalChooseWarehouseComponent } from './edit-product/modal-choose-warehouse/modal-choose-warehouse.component';
import { CoreModule } from '@app/core/core.module';
import { UserManagementModule } from '../user-management/user-management.module';
import { PortletModule } from '@app/views/partials/content/general/portlet/portlet.module';
import { NgxGalleryModule } from 'ngx-gallery';
import { LyResizingCroppingImageModule } from '@alyle/ui/resizing-cropping-images';
import { LySliderModule } from '@alyle/ui/slider';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { DeleteEntityDialogComponent } from '@app/views/partials/content/crud';
import { CurrencyPipe } from '@angular/common';
import { AppCatalogManagementComponent } from './catalog-management/app-catalog-management/app-catalog-management.component';
import { AppModalEditCatalogComponent } from './catalog-management/app-catalog-management/app-modal-edit-catalog/app-modal-edit-catalog.component';
import { AppTechnicalDocumentsComponent } from './catalog-management/app-catalog-management/app-technical-documents/app-technical-documents.component';
import { AppDrawImageComponent } from './catalog-management/app-catalog-management/app-technical-documents/app-draw-image/app-draw-image.component';
import { AppModalListProductKonvaComponent } from './catalog-management/app-catalog-management/app-technical-documents/app-modal-list-product-konva/app-modal-list-product-konva.component';
import { ModalChooseRepositoryComponent } from './edit-product/modal-choose-repository/modal-choose-repository.component';
import { HiddenProductComponent } from './product-management/hidden-product/hidden-product.component';
import { AppProducerManagementComponent } from './producer-management/app-producer-management/app-producer-management.component';
import { ModalCreateProducerComponent } from './producer-management/modal-create-producer/modal-create-producer.component';
import { AppBrandLogoManagementComponent } from './brand-logo-management/app-brand-logo-management/app-brand-logo-management.component';
import { AppDealsManagementComponent } from './deals-management/deals-management.component';
import { AppOrderManagementComponent } from './app-order-management/app-order-management.component';
import { AppPolicyPostsManagementComponent } from './app-policy-posts-management/app-policy-posts-management.component';
import { AppFooterManagementComponent } from './footer-management/footer-management.component';
import { AppAboutUsManagementComponent } from './about-us-management/about-us-management.component';
import { ModalEditAboutUsItemComponent } from './about-us-management/modal-edit-about-us-item/modal-edit-about-us-item.component';
import { AppGeneralSettingsComponent } from './general-settings/general-settings.component';
import { AppModalFooterManagementComponent } from './footer-management/component/app-model-edit-footer/app-modal-edit-footer.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
// NgBootstrap
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SatDatepickerModule, SatNativeDateModule, MAT_DATE_LOCALE } from 'saturn-datepicker';
import { CanActivateRouteGuard } from '@app/core/auth/_guards/permissions-route.guard';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { EditUserInfoComponent } from './manage-users/component/edit-user-info/edit-user-info.component';
import { PagesModule } from '../pages.module';
import { ManageVouchersComponent } from './manage-vouchers/manage-vouchers.component';
import { ModalVoucherComponent } from './manage-vouchers/component/modal-voucher/modal-voucher.component';
import { MatCurrencyFormatModule } from 'mat-currency-format';
import { VatConfigComponent } from './vat-config/vat-config.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { FooterGroupItemComponent } from './footer-management/footer-group-item/footer-group-item.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AttachmentManagementComponent } from './attachment-management/attachment-management.component';
import { ModalCreateAttachmentComponent } from './attachment-management/modal-create-attachment/modal-create-attachment.component';
import { ModalUploadFileComponent } from './attachment-management/modal-upload-file/modal-upload-file.component';
import { AttachmentCategoryManagementComponent } from './attachment-category-management/attachment-category-management.component';
import { ModalCreateAttachmentCategoryComponent } from './attachment-category-management/modal-create-attachment-category/modal-create-attachment-category.component';
import { UserTrackingComponent } from './user-tracking/user-tracking.component';
import { CreateOrderForCustomerComponent } from './create-order-for-customer/create-order-for-customer.component';
import { EquipmentModelManagementComponent } from './equipment-model-management/equipment-model-management/equipment-model-management.component';
import { ModalEquipmentModelComponent } from './equipment-model-management/modal-equipment-model/modal-equipment-model.component';
import {
  CompatibleProductManagementComponent,
  MapPrefixCodesPipe
} from './compatible-product-management/compatible-product-management/compatible-product-management.component';
import { ModalCompatibleProductComponent } from './compatible-product-management/modal-compatible-product/modal-compatible-product.component';
import { PartPackageManagementComponent } from './part-package-management/part-package-management/part-package-management.component';
import { ModalPartPackageComponent } from './part-package-management/modal-part-package/modal-part-package.component';
import { PartPackageDetailComponent } from './part-package-management/part-package-detail/part-package-detail.component';
import { AdminUserEquipmentComponent } from './admin-user-equipment/admin-user-equipment.component';
import { AdminMyEquipmentManagementComponent } from './admin-my-equipment-management/admin-my-equipment-management.component';
import { ModalEditUserEquipmentComponent } from './admin-my-equipment-management/modal-edit-user-equipment/modal-edit-user-equipment.component';
import { ModalViewUserEquipmentComponent } from './admin-my-equipment-management/modal-view-user-equipment/modal-view-user-equipment.component';
import { AdminEquipmentStatisticsComponent } from './admin-equipment-statistics/admin-equipment-statistics.component';
import { EquipmentTypeManagementComponent } from './equipment-type-management/equipment-type-management/equipment-type-management.component';
import { ModalEquipmentTypeComponent } from './equipment-type-management/modal-equipment-type/modal-equipment-type.component';
import { ModalManageBrandsComponent } from './equipment-type-management/modal-manage-brands/modal-manage-brands.component';
import { EquipmentCategoryManagementComponent } from './equipment-category-management/equipment-category-management/equipment-category-management.component';
import { ModalEquipmentCategoryComponent } from './equipment-category-management/modal-equipment-category/modal-equipment-category.component';
import { EquipmentTypeService } from '@app/api/equipmentType.service';
import { EquipmentCategoryService } from '@app/api/equipmentCategory.service';
import { BlogManagementComponent } from './blog-management/blog-post-management/blog-management.component';
import { BlogPostCreateComponent } from './blog-management/blog-post-create/blog-post-create.component';
import { BlogPostEditComponent } from './blog-management/blog-post-edit/blog-post-edit.component';
import { BlogPostPreviewComponent } from './blog-management/blog-post-preview/blog-post-preview.component';
import { BlogCategoryManagementComponent } from './blog-management/blog-category-management/blog-category-management.component';
import { BlogCategoryFormComponent } from './blog-management/blog-category-form/blog-category-form.component';
import { BlogTagManagementComponent } from './blog-management/blog-tag-management/blog-tag-management.component';
import { BlogTagFormComponent } from './blog-management/blog-tag-form/blog-tag-form.component';
import { ContactDepartmentManagementComponent } from './contact-management/contact-department-management/contact-department-management.component';
import { ContactDepartmentFormComponent } from './contact-management/contact-department-form/contact-department-form.component';
import { ContactPersonManagementComponent } from './contact-management/contact-person-management/contact-person-management.component';
import { ContactPersonFormComponent } from './contact-management/contact-person-form/contact-person-form.component';
import { ContactInquiryManagementComponent } from './contact-management/contact-inquiry-management/contact-inquiry-management.component';
import { ContactInquiryDetailComponent } from './contact-management/contact-inquiry-detail/contact-inquiry-detail.component';
import { PromoBannerManagementComponent } from './banner-management/promo-banner-management/promo-banner-management.component';
import { PromoBlogBannerFormComponent } from './banner-management/promo-banner-management/promo-blog-banner-form/promo-blog-banner-form.component';
import {
  PromoProductBannerFormComponent
} from './banner-management/promo-banner-management/promo-product-banner-form/promo-product-banner-form.component';

const routes: Routes = [
  {
    path: 'admin',
    component: DashboardComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/quote-management',
    component: AppGetQuoteListComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_SALESMAN'] }
  },
  {
    path: 'admin/brand-management',
    component: AppBrandManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/posts',
    component: AppPolicyPostsManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/blog-management',
    redirectTo: 'admin/blog-management/posts',
    pathMatch: 'full'
  },
  {
    path: 'admin/blog-management/posts',
    component: BlogManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'],
      section: 'posts',
      title: 'Bài viết'
    }
  },
  {
    path: 'admin/blog-management/categories',
    component: BlogCategoryManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'],
      section: 'categories',
      title: 'Danh mục'
    }
  },
  {
    path: 'admin/blog-management/tags',
    component: BlogTagManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'],
      section: 'tags',
      title: 'Thẻ'
    }
  },
  {
    path: 'admin/vat-config',
    component: VatConfigComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/warehouse-management',
    component: AppWarehouseManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/catalog-management',
    component: AppCatalogManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/catalog-management/:catalogId/document/:id/edit',
    component: AppTechnicalDocumentsComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/catalog-management/:catalogId/document/create',
    component: AppTechnicalDocumentsComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/producer-management',
    component: AppProducerManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/product-management',
    component: ProductManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/product-management/create',
    component: EditProductComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/product-management/:productId/edit',
    component: EditProductComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/brand-logo-management',
    component: AppBrandLogoManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/deals-management',
    component: AppDealsManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/order-management',
    component: AppOrderManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_SALESMAN'] }
  },
  {
    path: 'admin/create-order-for-customer',
    component: CreateOrderForCustomerComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_SALESMAN'] }
  },
  {
    path: 'admin/dashboard',
    component: DashboardComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_SALESMAN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/manage-users',
    component: ManageUsersComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/user-tracking',
    component: UserTrackingComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/manage-vouchers',
    component: ManageVouchersComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_SALESMAN'] }
  },
  {
    path: 'admin/promo-banner-management',
    component: PromoBannerManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'],
      title: 'Quản lý Promo Banner'
    }
  },
  {
    path: 'admin/general-settings',
    component: AppGeneralSettingsComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/footer-management',
    component: AppFooterManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/about-us-management',
    component: AppAboutUsManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'],
      title: 'Quản lý Về chúng tôi'
    }
  },
  {
    path: 'admin/attachment-management',
    component: AttachmentManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/attachment-category-management',
    component: AttachmentCategoryManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/equipment-model-management',
    component: EquipmentModelManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/equipment-type-management',
    component: EquipmentTypeManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/equipment-category-management',
    component: EquipmentCategoryManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/compatible-product-management',
    component: CompatibleProductManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/part-package-management',
    component: PartPackageManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/part-package-management/:packageId/items',
    component: PartPackageDetailComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'] }
  },
  {
    path: 'admin/user-equipment/:userId',
    component: AdminUserEquipmentComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/user-equipment/:userId/:equipmentId/orders',
    component: AdminUserEquipmentComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/my-equipment-management',
    component: AdminMyEquipmentManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/equipment-statistics',
    component: AdminEquipmentStatisticsComponent,
    canActivate: [CanActivateRouteGuard],
    data: { permissions: ['SYS_ADMIN'] }
  },
  {
    path: 'admin/contact-management',
    redirectTo: 'admin/contact-management/departments',
    pathMatch: 'full'
  },
  {
    path: 'admin/contact-management/departments',
    component: ContactDepartmentManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN'],
      section: 'departments',
      title: 'Phòng ban / Tabs'
    }
  },
  {
    path: 'admin/contact-management/persons',
    component: ContactPersonManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN', 'SYS_SALESMAN'],
      section: 'persons',
      title: 'Nhân sự liên hệ'
    }
  },
  {
    path: 'admin/contact-management/inquiries',
    component: ContactInquiryManagementComponent,
    canActivate: [CanActivateRouteGuard],
    data: {
      permissions: ['SYS_ADMIN', 'SYS_CONTENT_ADMIN', 'SYS_SALESMAN'],
      section: 'inquiries',
      title: 'Thư liên hệ'
    }
  }
];
@NgModule({
  declarations: [
    AppGetQuoteListComponent,
    AppGetQuoteNoteComponent,
    AppBrandManagementComponent,
    ModalCreateBrandComponent,
    ModalCreatePostsPolicyComponent,
    AppWarehouseManagementComponent,
    ModalCreateWarehouseComponent,
    AppGetQuoteNoteComponent,
    ProductManagementComponent,
    EditProductComponent,
    AllProductComponent,
    ModalUploadImageComponent,
    ModalTreeCategoryComponent,
    InStockComponent,
    OutOfStockComponent,
    ZoomImageComponent,
    ModalChooseWarehouseComponent,
    AppCatalogManagementComponent,
    AppModalEditCatalogComponent,
    AppTechnicalDocumentsComponent,
    AppDrawImageComponent,
    AppModalListProductKonvaComponent,
    ModalChooseRepositoryComponent,
    HiddenProductComponent,
    AppProducerManagementComponent,
    ModalCreateProducerComponent,
    AppBrandLogoManagementComponent,
    AppDealsManagementComponent,
    AppOrderManagementComponent,
    DashboardComponent,
    ManageUsersComponent,
    EditUserInfoComponent,
    ManageVouchersComponent,
    ModalVoucherComponent,
    VatConfigComponent,
    AppPolicyPostsManagementComponent,
    AppGeneralSettingsComponent,
    AppAboutUsManagementComponent,
    ModalEditAboutUsItemComponent,
    AppFooterManagementComponent,
    AppModalFooterManagementComponent,
    FooterGroupItemComponent,
    AttachmentManagementComponent,
    ModalCreateAttachmentComponent,
    ModalUploadFileComponent,
    AttachmentCategoryManagementComponent,
    ModalCreateAttachmentCategoryComponent,
    UserTrackingComponent,
    CreateOrderForCustomerComponent,
    EquipmentModelManagementComponent,
    ModalEquipmentModelComponent,
    CompatibleProductManagementComponent,
    MapPrefixCodesPipe,
    ModalCompatibleProductComponent,
    PartPackageManagementComponent,
    ModalPartPackageComponent,
    PartPackageDetailComponent,
    AdminUserEquipmentComponent,
    AdminMyEquipmentManagementComponent,
    ModalEditUserEquipmentComponent,
    ModalViewUserEquipmentComponent,
    AdminEquipmentStatisticsComponent,
    EquipmentTypeManagementComponent,
    ModalEquipmentTypeComponent,
    ModalManageBrandsComponent,
    EquipmentCategoryManagementComponent,
    ModalEquipmentCategoryComponent,
    BlogManagementComponent,
    BlogPostCreateComponent,
    BlogPostEditComponent,
    BlogPostPreviewComponent,
    BlogCategoryManagementComponent,
    BlogCategoryFormComponent,
    BlogTagManagementComponent,
    BlogTagFormComponent,
    ContactDepartmentManagementComponent,
    ContactDepartmentFormComponent,
    ContactPersonManagementComponent,
    ContactPersonFormComponent,
    ContactInquiryManagementComponent,
    ContactInquiryDetailComponent,
    PromoBannerManagementComponent,
	PromoBlogBannerFormComponent,
	PromoProductBannerFormComponent
  ],
  exports: [RouterModule, AllProductComponent],
  imports: [
    SharedModule,
    MatDialogModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    CommonModule,
    HttpClientModule,
    FormsModule,
    CoreModule,
    PartialsModule,
    UserManagementModule,
    MaterialModule,
    PortletModule,
    ReactiveFormsModule,
    NgxGalleryModule,
    CommonElementModule,
    NgxMatSelectSearchModule,
    LyResizingCroppingImageModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    NgxDropzoneModule,
    NgbDropdownModule,
    NgbModule,
    NgxSummernoteModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatAutocompleteModule,
    SatDatepickerModule,
    SatNativeDateModule,
    PagesModule,
    MatCurrencyFormatModule,
    TranslateModule.forChild()
  ],
  providers: [
    CurrencyPipe,
    EquipmentTypeService,
    EquipmentCategoryService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true
    }
  ],
  entryComponents: [
    AppGetQuoteNoteComponent,
    ModalUploadImageComponent,
    ModalTreeCategoryComponent,
    ModalChooseWarehouseComponent,
    ModalCreateBrandComponent,
    ModalCreatePostsPolicyComponent,
    ModalCreateWarehouseComponent,
    DeleteEntityDialogComponent,
    ModalCreateProducerComponent,
    ModalChooseRepositoryComponent,
    AppModalEditCatalogComponent,
    AppModalListProductKonvaComponent,
    EditUserInfoComponent,
    ModalVoucherComponent,
    AppModalFooterManagementComponent,
    ModalEditAboutUsItemComponent,
    ModalCreateAttachmentComponent,
    ModalUploadFileComponent,
    ModalCreateAttachmentCategoryComponent,
    ModalEquipmentModelComponent,
    ModalCompatibleProductComponent,
    ModalPartPackageComponent,
    ModalEquipmentTypeComponent,
    ModalManageBrandsComponent,
    ModalEquipmentCategoryComponent,
    ModalEditUserEquipmentComponent,
    ModalViewUserEquipmentComponent,
    BlogPostCreateComponent,
    BlogPostEditComponent,
    BlogPostPreviewComponent,
    BlogCategoryFormComponent,
    BlogTagFormComponent,
    ContactDepartmentFormComponent,
    ContactPersonFormComponent,
    ContactInquiryDetailComponent,
	PromoBlogBannerFormComponent,
	PromoProductBannerFormComponent
  ]
})
export class AdminPageModule {}
